import { motion } from "framer-motion";
import { Apple, MapPin } from "lucide-react";
import { toast } from "sonner";
import { scrollToId } from "@/lib/scroll";

export const comingSoonToast = () =>
    toast("Almost there", {
        description: "We're putting the finishing touches on the App Store listing. The download link goes live here soon.",
    });

const links = [
    { label: "The App", target: "#features", testid: "header-features-link" },
    { label: "FAQ", target: "#faq", testid: "header-faq-link" },
    { label: "Support", target: "#support", testid: "header-support-link" },
];

export default function Navbar() {
    return (
        <motion.header
            initial={{ y: -80, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
            className="fixed top-0 left-0 right-0 z-50 border-b border-white/5 bg-[#06070B]/80 backdrop-blur-xl"
            data-testid="header-navbar"
        >
            <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 sm:px-8">
                <button
                    onClick={() => scrollToId("#top")}
                    className="flex items-center gap-2.5"
                    data-testid="header-app-logo"
                >
                    <span className="flex h-9 w-9 items-center justify-center rounded-lg border border-neon-cyan/40 bg-neon-cyan/10">
                        <MapPin className="h-5 w-5 text-neon-cyan" strokeWidth={2.2} />
                    </span>
                    <span className="font-display text-xs font-bold tracking-[0.18em] text-white sm:text-sm">
                        LV RESTROOM <span className="text-neon-cyan neon-cyan">LOCATOR</span>
                    </span>
                </button>

                <nav className="hidden items-center gap-8 md:flex">
                    {links.map((l) => (
                        <button
                            key={l.label}
                            onClick={() => scrollToId(l.target)}
                            data-testid={l.testid}
                            className="font-mono text-xs uppercase tracking-[0.2em] text-slate-400 transition-colors duration-300 hover:text-neon-cyan"
                        >
                            {l.label}
                        </button>
                    ))}
                </nav>

                <button
                    onClick={comingSoonToast}
                    data-testid="header-app-store-cta"
                    className="group flex items-center gap-2 rounded-full border border-neon-magenta/50 bg-neon-magenta/10 px-4 py-2 font-mono text-xs uppercase tracking-widest text-white transition-all duration-300 hover:bg-neon-magenta/25 hover:shadow-[0_0_24px_rgba(255,0,122,0.4)]"
                >
                    <Apple className="h-4 w-4" />
                    <span className="hidden sm:inline">App Store</span>
                    <span className="h-1.5 w-1.5 rounded-full bg-neon-emerald animate-neon-pulse" />
                </button>
            </div>
        </motion.header>
    );
}
